module.exports = __webpack_public_path__ + "static/img/logo-min.57435bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-min.jpg
// module id = Kmo0
// module chunks = 24